export const clutch_cage_jacket = {
  msrp: 54.99,
  variants: [['SHORT SLEEVE', 'LONG SLEEVE']],
  infoLink: 'https://www.teamtriton.com/clutch-sublimated-cage-jacket.html',
  items: [
    {
      number: 'CC99',
      hasModel: false,
    },
    {
      number: 'CC100',
      hasModel: false,
    },
    {
      number: 'CC101',
      hasModel: false,
    },
    {
      number: 'CC102',
      hasModel: false,
    },
    {
      number: 'CC103',
      hasModel: false,
    },
    {
      number: 'CC104',
      hasModel: false,
    },
    {
      number: 'CC105',
      hasModel: false,
    },
    {
      number: 'CC106',
      hasModel: false,
    },
    {
      number: 'CC107',
      hasModel: false,
    },
    {
      number: 'CC108',
      hasModel: false,
    },
    {
      number: 'CC109',
      hasModel: false,
    },
    {
      number: 'CC110',
      hasModel: false,
    },
  ],
};
